import { Button, Flex, Text } from 'rebass';
import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { LogoSvg } from './Logo';
import { Input } from '../../../components/TextInput';
import ReactInputMask from 'react-input-mask';
import { isMobile } from 'react-device-detect';

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

export const Dob = ({ title, state, id, onChange, onContinue }) => {
  const selectRef = useRef(null);
  
  const handleButtonClick = () => {
    if (selectRef.current) {
      selectRef.current.focus();
    }
  };

  return (
    <Flex flex={1} flexDirection={'column'}>
      <LogoSvg />
      <Text style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500 }} textAlign={isMobile?'center': ''} mb={4}>
        To verify eligibility, tell us your date of birth:
      </Text>

      <Flex
        flexDirection={'row'}
        onClick={handleButtonClick}
        style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 16px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
      >
        <Flex flex={1} flexDirection={'column'}>
          <Text mb={0} style={{ opacity: 0.7 }} fontSize={'13px'} fontWeight={500}>
            MM/DD/YYYY
          </Text>
          <ReactInputMask
            name="dob"
            placeholder="Your Date of Birth (MM/DD/YYYY)"
            mask="99/99/9999"
            value={state['dob']}
            onChange={(e) => {
              // console.log(e);
              onChange('dob', e.target.value);
            }}
          >
            {(inputProps) => <Input style={{ border: 0, background: 'white', color: '#344f79', padding: '16px 0' }} subref={selectRef} {...inputProps} />}
          </ReactInputMask>
        </Flex>
      </Flex>

      <FootNote mb={4}>
        <Button variant={'primary'} onClick={onContinue} disabled={!(state || {})['dob'] || (state || {})['dob'].indexOf('_') > -1}>
          Continue
        </Button>
      </FootNote>
    </Flex>
  );
};
